import classNames from 'classnames/bind';
import React, { useMemo } from 'react';

import Spinner from '../Spinner';
import styles from './styles.module.scss';

export const BUTTON_STYLE_TYPE = {
    WHITE: 'white',
    BLUE: 'blue',
    PURPLE: 'purple'
};

const CustomButton = (props) => {
    const {
        onClick = () => {},
        LeftIcon = null,
        text = '',
        disable = false,
        loading = false,
        fontKhand = false,
        type = undefined,
        styleType = BUTTON_STYLE_TYPE.WHITE,
        extraClasses = []
    } = props;
    const onBtnClick = () => {
        if (loading) {
            return;
        }
        onClick();
    };
    const stylesConfig = useMemo(
        () => ({
            white: [styles.btnWhite, styles.textDark],
            blue: [styles.btnBlue, styles.textWhite],
            purple: [styles.btnPurple, styles.textWhite]
        }),
        []
    );

    const typesStyle = useMemo(() => {
        return stylesConfig[styleType] || stylesConfig.white;
    }, [styleType, stylesConfig]);

    return (
        <button
            disabled={disable || loading}
            type={type}
            onClick={onBtnClick}
            className={classNames(
                styles.btn,
                ...typesStyle,
                ...extraClasses,
                { [styles.disabled]: disable },
                { [styles.fontKhand]: fontKhand }
            )}
        >
            {loading ? (
                <Spinner width={30} height={30} {...(styleType == BUTTON_STYLE_TYPE.BLUE ? { fill: '#ffffff' } : {})} />
            ) : (
                <>
                    {LeftIcon && <span className={styles.leftIcon}>{<LeftIcon />}</span>}
                    {!!text && text}
                </>
            )}
        </button>
    );
};

export default CustomButton;
